import React from "react";
import { Link } from "react-router-dom";
import '../AppsPage.css';

import { handleOpenExternalURL } from '../../../Utilities/Functions'

import appstore from '../../../Assets/Apps/appstore.png'
import playstore from '../../../Assets/Apps/playstore.png'

import screenshot1 from '../../../Assets/Apps/Speak2Roll/speak2roll screenshot1.png'
import screenshot2 from '../../../Assets/Apps/Speak2Roll/speak2roll screenshot2.png'
import screenshot3 from '../../../Assets/Apps/Speak2Roll/speak2roll screenshot3.png'

const Speak2Roll = () => {

    const linksStyle = {
        textDecoration: 'none',
        color: 'black'
    }

    return(
        <div className='main'>
            <center>
                <h1 className='page-title'>Speak2Roll</h1>
            </center>

            <div className='app-page-download'>
                <img 
                    src={appstore}
                    className='app-page-store-image'
                    alt='App Store Logo'
                    onClick={() => handleOpenExternalURL('https://apps.apple.com/at/app/speak2roll/id6761303985?l=en-GBSpeak2Roll')}
                />
                <img 
                    src={playstore}
                    className='app-page-store-image'
                    alt='App Store Logo'
                    onClick={() => handleOpenExternalURL('https://play.google.com/store/apps/details?id=com.aakash143.Teleprompter')}
                />
            </div>

            <p className='text'>
                Just speak. Your script follows your voice.
                <br></br><br></br>
                Teleprompter - Speak2Roll uses real-time voice recognition to move your script at your natural pace. Speed up, slow down, pause to think. The teleprompter stays with you. No remote control needed, no fixed scroll speed to fight against.
                <br></br><br></br>
                Built for creators who script in multiple languages. Voice tracking works with Hindi, English, and Hinglish mixed scripts out of the box, so you can switch between languages mid-sentence without losing sync.
                <br></br><br></br>
                A bright yellow highlighter follows your voice word by word, so you always know exactly where you are in your script. No more losing your place during long recordings.
                <br></br><br></br>
                HOW IT WORKS
                <br></br>
                Paste your script, tap record, start speaking. The app listens through your device microphone and scrolls automatically as you read. If you go off-script or pause to ad-lib, it waits for you. When you return to the text, it picks right back up.
                <br></br><br></br>
                FEATURES
                <br></br>
                Voice-Activated Scrolling: Your script moves when you speak and stops when you stop. Works with Hindi, English, and bilingual scripts.<br></br>
                Live Voice Highlighter: A yellow highlight tracks your spoken words in real time so you never lose your position, even in scripts over 7,000 words.<br></br>
                Script Library: Save, organize, and reload your scripts. No more copy-pasting the same text before every session.<br></br>
                Quick Paste Workflow: One-tap clear and paste gets your new script loaded in seconds. Built for fast turnaround between takes.<br></br>
                Horizontal and Vertical Mirroring: Flip your text for use with beam-splitter teleprompter rigs or any mirrored display setup.<br></br>
                Manual Scroll Override: Touch and drag at any time to jump ahead or scroll back, even while voice tracking is active.<br></br>
                <br></br><br></br>
                BUILT FOR
                <br></br>
                YouTubers and content creators recording talking-head videos. Podcasters and online course instructors reading from prepared scripts. Public speakers, presenters, and educators practicing or delivering speeches. Live streamers who need a floating script while on camera. Anyone who records video in Hindi, English, or any mix of both.
            </p>
            <div className='app-page-screenshots'>
                <img 
                    src={screenshot1}
                    className='app-page-images'
                    alt='Dhruv Rathee screenshot'
                />
                <img 
                    src={screenshot2}
                    className='app-page-images'
                    alt='Dhruv Rathee screenshot'
                />
                <img 
                    src={screenshot3}
                    className='app-page-images'
                    alt='Dhruv Rathee screenshot'
                />
            </div>

            <center>
                <Link to='/apps/speak2roll/privacy-policy' style={linksStyle}>
                    <h3 className='link'>Privacy Policy</h3>
                </Link>
                <Link to='/apps/speak2roll/eula' style={linksStyle}>
                    <h3 className='link'>EULA</h3>
                </Link>
            </center>
        
        </div>
    )
}

export default Speak2Roll